
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'Ballots',
  computed: mapState(['ballots'])
})
